import { writable } from 'svelte/store';

export const formUrl = writable();

export const isToggleButton = writable(false);

const createSelectedRadios = () => {

  const store = writable({});

  return {
    subscribe: store.subscribe,
    updateRadio: (name, id) => {
      store.update(selected => {
        // Remove inactive radio selections
        const updatedSelected = Object.fromEntries(
          Object.entries(selected).filter(([key]) => key !== id)
        );

        return { ...updatedSelected, [id]: name };
      });
    },
  };
};
export const selectedRadios = createSelectedRadios();

export function handleRadioClick(name, id) {
  selectedRadios.updateRadio(name, id);
}

export const selectedChecks = writable({});

export function handleCheckboxClick(name, isChecked, aantal) {
    selectedChecks.update(checks => {
        if (isChecked) {
            const obj = {
                id: name,
                aantal: aantal
            }
            return {...checks, [name]: obj};
        } else {
            const updatedChecks = Object.fromEntries(
                Object.entries(checks).filter(([key]) => key !== name)
            );
            return updatedChecks;
        }
    });
}

export const selectedSwitches = writable({});

export function handleSwitchClick(name, isChecked, aantal) {
    selectedSwitches.update(checks => {
        if (isChecked) {
            const obj = {
                id: name,
            }
            return {...checks, [name]: obj};
        } else {
            const updatedChecks = Object.fromEntries(
                Object.entries(checks).filter(([key]) => key !== name)
            );
            return updatedChecks;
        }
    });
}

export function changeAantal(name, aantal) {
    selectedChecks.update(checks => {
        const obj = {
            id: name,
            aantal: aantal
        }
        return {...checks, [name]: obj}
    })
}